import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EditUserModal = ({ show, handleClose, user, handleSave, rolesMap }) => {
    const [editedUser, setEditedUser] = useState({ ...user });

    useEffect(() => {
        setEditedUser({ ...user });
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedUser(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        handleSave(editedUser);
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Modifier l'utilisateur : {editedUser.id}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="formUserId">
                        <Form.Label>ID</Form.Label>
                        <Form.Control
                            type="text"
                            name="id"
                            value={editedUser.id}
                            onChange={handleChange}
                            readOnly
                        />
                    </Form.Group>
                    <Form.Group controlId="formUserName">
                        <Form.Label>Nom</Form.Label>
                        <Form.Control
                            type="text"
                            name="nom"
                            value={editedUser.nom}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group controlId="formUserEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            name="email"
                            value={editedUser.email}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group controlId="formUserTele">
                        <Form.Label>Téléphone</Form.Label>
                        <Form.Control
                            type="text"
                            name="tele"
                            value={editedUser.tele}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group controlId="formUserRole">
                        <Form.Label>Rôle</Form.Label>
                        <Form.Control
                            as="select"
                            name="role"
                            value={editedUser.role}
                            onChange={handleChange}
                        >
                            <option value="">Sélectionner un rôle</option>
                            {rolesMap && Object.entries(rolesMap).map(([roleId, roleName]) => (
                                <option key={roleId} value={roleId}>{roleName}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <br/>
                    <Button variant="primary" type="submit">
                        Sauvegarder
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditUserModal;
